import type { StateNoticeTone } from './StateNotice.tsx'

/**
 * 에러 한 건 → 톤. **막힌 것과 깨진 것을 가른다.**
 *
 * 🔴 401·403 은 「막힘」이다 — 다시 눌러도 같고, 사람이 할 일은 역할을 바꾸는 것이다.
 *    나머지(통신 끊김 · 5xx · 계약 봉투 밖 응답)는 「실패」라 다시 하면 달라질 수 있다.
 * ⚠ 형태만 본다 — `ApiError` 를 `instanceof` 로 보면 원자가 상위 패키지(`@ctcells/api`)를
 *   참조하게 된다. `status` 를 든 객체면 무엇이든 받는다.
 * ⚠ 컴포넌트 파일과 갈라 둔 것은 핫리로드 때문이다(`react-refresh/only-export-components`).
 */
export function noticeToneOf(error: unknown): StateNoticeTone {
  const status = (error as { status?: unknown } | null)?.status
  return status === 401 || status === 403 ? 'blocked' : 'failed'
}
